import { useQuery } from "react-query";
import { GET_VARIABLES_IMPACTING_TREATMENT, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getVariablesImpactingTreatment } from "api/customers";

const useGetVariablesImpactingTreatment = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_VARIABLES_IMPACTING_TREATMENT, clientId],
    () => getVariablesImpactingTreatment(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    variablesImpactingTreatment: data?.data || null,
    variablesImpactingTreatmentLoading: isLoading,
    refetchVariablesImpactingTreatment: refetch,
    ...rest,
  };
};

export default useGetVariablesImpactingTreatment;
